import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import portal from "portalConfig"

if (portal.locale) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      load: "languageOnly",
      react: { useSuspense: false },
      debug: false,
      defaultNS: portal.ns,
      resources: Object.fromEntries(
        Object.entries(portal.locale).map(([lng, translations]) => [
          lng,
          { [portal.ns]: translations }
        ])
      ),
      interpolation: { escapeValue: false }
    })
}

export default i18n
